import { defineComponent, PropType, shallowRef, ComponentPublicInstance, VNode } from 'vue';

import HiddenFileSelector from './hidden-file-selector';

import { AttachmentAcceptType } from '@/types/Attachment';

import './file-input.scss';

const CN = 'file-input';

export default defineComponent({
  props: {
    accept: { type: String as PropType<AttachmentAcceptType>, required: true },
    fileName: { type: String, default: () => '' },
    label: { type: String, default: () => '' },
    processing: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },

    onFileSelected: { type: Function as PropType<(file: File) => void>, required: true },
    onClear: { type: Function as PropType<() => void>, required: true },
  },
  emits: {
    clear: () => true,
  },
  inheritAttrs: false,
  setup(props, ctx) {
    const hidden = shallowRef<ComponentPublicInstance | null>(null);

    const openFileSelector = () => {
      if (hidden.value && hidden.value.$el instanceof HTMLElement) {
        hidden.value.$el.click();
      }
    };

    return () => {
      let action: VNode | undefined;
      if (props.processing) {
        action = (
          <spinner think class={`${CN}__spinner`} data-testid="file-input-spinner" size="sm" />
        );
      } else if (props.fileName) {
        action = (
          <r-button
            aria-label="Remove file"
            class={`${CN}__action`}
            color="primary"
            data-testid="file-input-cancel-action"
            icon="cancel"
            mode="frameless"
            onclick={props.onClear}
          />
        );
      }
      return (
        <div class={CN}>
          <HiddenFileSelector
            ref={hidden}
            accept={props.accept}
            class={`${CN}__field`}
            onFileSelected={props.onFileSelected}
          />
          <text-field
            readOnly
            class={`${CN}__field`}
            disabled={props.processing}
            icon="attachment"
            label={props.label}
            onclick={openFileSelector}
            placeholder={props.placeholder}
            v-slots={{ actions: () => action }}
            value={props.fileName}
            {...ctx.attrs}
          />
        </div>
      );
    };
  },
}) as any;
